import { amenitySiteCards } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function SiteCrossSell() {
  return (
    <section id="sites" aria-labelledby="sites-heading" className="bg-background py-16 md:py-20">
      <div className="shell">
        <Reveal>
          <Eyebrow>Pair Comfort with the Right Site</Eyebrow>
        </Reveal>
        <h2 id="sites-heading" className="display-lg mt-6 max-w-[18ch]">
          <MaskReveal>Find the RV Site That</MaskReveal>
          <MaskReveal delay={0.08}>Fits Your Journey</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground">
            Choose from pull-through, back-in and accessible RV sites with full hookups and flexible
            daily, weekly and monthly stay options.
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-6 md:grid-cols-3">
          {amenitySiteCards.map((site, i) => (
            <li key={site.id}>
              <Reveal delay={i * 0.06} className="h-full">
                <a href={site.href} className="group block h-full">
                  <article>
                    <img
                      src={site.image}
                      alt={`${site.title} RV sites at Auburn RV Resort`}
                      width={900}
                      height={1100}
                      loading="lazy"
                      decoding="async"
                      className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                    />
                    <h3 className="font-display mt-6 text-2xl tracking-tight">{site.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                      {site.copy}
                    </p>
                  </article>
                </a>
              </Reveal>
            </li>
          ))}
        </ul>

        <Reveal delay={0.12}>
          <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ResortLink variant="solid" href="/accommodations/" className="w-full sm:w-auto">
              Explore Accommodations
            </ResortLink>
            <ResortLink variant="outline" href="/rates/" className="w-full sm:w-auto">
              View Rates
            </ResortLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
